import { createRoot } from "react-dom/client";
import Modal from "react-modal";
import App from "./App";

// Configurar react-modal para acessibilidade
Modal.setAppElement("#root");

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);
